// Styles
import './styles/app.scss';
// Images
// require.context('./images', true, /.*/);
// Javascript
import React from 'react';
import ReactDOM from 'react-dom';
import Application from './scripts/Application';
// Render DOM
ReactDOM.render(React.createElement(Application, null), document.querySelector("#root"));
